import {
	requestTablet2List,
	registTablet2,
	requestTablet2Delete
} from "@/apis/tablet2_api";

const state = {
	tablet2List: [],
	tablet2Page: null,
	tablet2PageTotal: 0,
	tablet2TotalElemtnts: 0,
};

const getters = {
	getTablet2List(state) {
		return state.tablet2List;
	},
	getTablet2Page(state) {
		if (state.tablet2Page === null) {
			return 0;
		} else {
			return state.tablet2Page.pageNumber + 1;
		}
	},
	getTablet2PageTotal(state) {
		return state.tablet2PageTotal;
	},
	getTablet2TotalElements(state) {
		return state.tablet2TotalElemtnts;
	},
};

const mutations = {
	TABLET2_LIST(state, data) {
		state.tablet2List = data.resultTablet2List
		state.tablet2Page = data.page
		state.tablet2PageTotal = data.pageTotal
		state.tablet2TotalElemtnts = data.totalElemtnts
	},
	TABLET2_LIST_ADD(state, data) {
		state.tablet2List = [].concat.apply(state.tablet2List, data.resultTablet2List);
		state.tablet2Page = data.page
		state.tablet2PageTotal = data.pageTotal
		state.tablet2TotalElemtnts = data.totalElemtnts
	},
	TABLET2_INIT(state) {
		state.tablet2List = []
		state.tablet2Page = null
		state.tablet2PageTotal = 0
		state.tablet2TotalElemtnts = 0
	}
};

const actions = {
	async REQUEST_TABLET2_DELETE(context, id) {
		try {
			context.commit('START_LOADING');
			const response = await requestTablet2Delete(id);
			if (response.data !== null && response.data !== undefined && response.data.result === 'success') {
				context.commit("TABLET2_LIST", response.data);
			} else {
				alert(response.data.message);
			}
			context.commit('END_LOADING');
		} catch (e) { if(e==='refresh'){ return }
			context.commit('END_LOADING');
		}
		context.commit('END_LOADING');
	},
	async REQUEST_TABLET2_LIST(context, parameter) {
		try {
			context.commit('START_LOADING');
			const response = await requestTablet2List(parameter);
			if (response.data !== null && response.data !== undefined && response.data.result === 'success') {
				context.commit("TABLET2_LIST", response.data);
			} else {
				alert(response.data.message);
			}
			context.commit('END_LOADING');
		} catch (e) { if(e==='refresh'){ return }
			context.commit('END_LOADING');
		}
		context.commit('END_LOADING');
	},
	async REGIST_TABLET2(context, parameter) {
		try {
			context.commit('START_LOADING');
			const response = await registTablet2(parameter);
			if (response.data !== null && response.data !== undefined && response.data.result === 'success') {

			} else {
				alert(response.data.message);
			}
			context.commit('END_LOADING');
		} catch (e) { if(e==='refresh'){ return }
			context.commit('END_LOADING');
		}
		context.commit('END_LOADING');
	},
};

export default { mutations, state, actions, getters };